module.exports = __webpack_public_path__ + "img/wsjg.98113c78.png";